/* eslint-disable */
export default {
    init() {
        // JavaScript to be fired on the ACT Registration page
        $(() => {
            var events = $('#calendar').data('events');
            var startDate = $('#calendar').data('start-date');
            var endDate = $('#calendar').data('end-date');
            $('#calendar').fullCalendar({
                themeSystem: 'bootstrap4',
                defaultView: 'agendaDay',
                defaultDate: startDate,
                allDaySlot: false,
                // customButtons: {
                //     day1: {
                //         text: 'ACT Day 1',
                //         click: function() {
                //             $('#calendar').fullCalendar( 'gotoDate', startDate );
                //         },
                //     },
                //     day2: {
                //         text: 'ACT Day 2',
                //         click: function() {
                //             $('#calendar').fullCalendar( 'gotoDate', endDate );
                //         },
                //     },
                // },
                header: {
                    left: 'day1,day2',
                    center: 'title',
                    right: 'agendaDay',
                },
                events: events,
                eventClick: function(calEvent, jsEvent, view) {

                    // Set the html dynamically
                    var template = '<ul class="list-group">';
                    Object.keys(calEvent.calendars).forEach(function (item) {
                        // console.log(item); // key
                        // console.log(calEvent.calendars[item]); // value
                        template += `<li class="list-group-item"><a href="${calEvent.calendars[item]['link']}" target="_blank">${calEvent.calendars[item]['name']}</a></li>`;
                    });
                    template += '</ul>';

                    $('#exampleModal').find('.modal-body').html(template);
                    $('#exampleModal').modal('show');
                  },
            });
        });
    },
    finalize() {
        // JavaScript to be fired on the ACT Registration page, after the init JS
    },
};
  


// WEBPACK FOOTER //
// ./scripts/routes/schedule.js